import {
    LOADING,
    ON_FAIL_REISSUE,
    ON_FAIL_REISSUE_GENERAL,
    ON_FAIL_REISSUE_NONPAYMENT,
    ON_SUCCESS,
    ON_FAIL_REISSUE_VARIATION,
    ON_WARNING_CONFIRMATION,
    ON_CANCEL_WARNING_CONFIRMATION,
    ON_RESET_REISSUE
} from "../types/reissueTypes";

const initialState = {
    loading: false,
    emissionRS: null,
    errorMsg: "",
    errorMsgValue: "",
    errorType: "warning",
    success: false,
    hasVariationOffer: false,
    variation: null,
    hasWarningConfirmation: false,
    warningConfirmationMessage: "",
    hasAcceptedWarningConfirmation: false,
    pendingReissueRQ: null
};

export default function(state = initialState, action) {
    switch (action.type) {
        case ON_RESET_REISSUE:
            return { ...initialState };
        case LOADING:
            return {
                ...state,
                loading: true,
                errorMsg: "",
                errorMsgValue: "",
                errorType: "warning",
                hasVariationOffer: false,
                hasWarningConfirmation: false,
                warningConfirmationMessage: ""
            };
        case ON_SUCCESS:
            return {
                ...state,
                loading: false,
                emissionRS: action.payload,
                success: true,
                errorMsg: "",
                errorMsgValue: "",
                errorType: "warning",
                hasVariationOffer: false,
                hasWarningConfirmation: false,
                warningConfirmationMessage: "",
                hasAcceptedWarningConfirmation: false,
                pendingReissueRQ: null
            };
        case ON_WARNING_CONFIRMATION:
            return {
                ...state,
                loading: false,
                success: false,
                errorMsg: "",
                errorMsgValue: "",
                errorType: "warning",
                hasVariationOffer: false,
                hasWarningConfirmation: true,
                warningConfirmationMessage: action.message || "",
                hasAcceptedWarningConfirmation: false,
                pendingReissueRQ: action.pendingReissueRQ
            };
        case ON_CANCEL_WARNING_CONFIRMATION:
            return {
                ...state,
                loading: false,
                hasWarningConfirmation: false,
                warningConfirmationMessage: "",
                hasAcceptedWarningConfirmation: false,
                pendingReissueRQ: null
            };
        case ON_FAIL_REISSUE_GENERAL:
            return {
                ...state,
                loading: false,
                errorMsg: action.errorMsg || "Hemos recibido un error en la remisión, comunicarse con el equipo TI para ver el motivo.",
                errorMsgValue: action.errorMsgValue || "",
                errorType: action.errorType || "danger",
                success: false,
                hasWarningConfirmation: false,
                warningConfirmationMessage: "",
                hasAcceptedWarningConfirmation: false,
                pendingReissueRQ: null
            };
        case ON_FAIL_REISSUE:
            return {
                ...state,
                loading: false,
                errorMsg: action.errorMsg || "Error interno. Por favor comunicarse con el equipo de TI.",
                errorMsgValue: action.errorMsgValue || "",
                errorType: action.errorType || "danger",
                success: false,
                hasWarningConfirmation: false,
                warningConfirmationMessage: "",
                hasAcceptedWarningConfirmation: false,
                pendingReissueRQ: null
            };
        case ON_FAIL_REISSUE_NONPAYMENT:
            return {
                ...state,
                loading: false,
                errorMsg: action.errorMsg || "La remisión no se pudo realizar. Por favor, inténtelo nuevamente en unos minutos.",
                errorMsgValue: action.errorMsgValue || "",
                errorType: action.errorType || "warning",
                success: false,
                hasWarningConfirmation: false,
                warningConfirmationMessage: "",
                hasAcceptedWarningConfirmation: false,
                pendingReissueRQ: null
            };
        case ON_FAIL_REISSUE_VARIATION:
            return {
                ...state,
                loading: false,
                success: false,
                errorMsg: action.errorMsg || "",
                errorMsgValue: action.errorMsgValue || "",
                errorType: action.errorType || "warning",
                hasVariationOffer: action.hasVariationOffer || false,
                variation: action.variation,
                hasWarningConfirmation: false,
                warningConfirmationMessage: "",
                hasAcceptedWarningConfirmation: action.hasAcceptedWarningConfirmation || state.hasAcceptedWarningConfirmation || false,
                pendingReissueRQ: null
            };
        default:
            return state;
    }
}
